import { Currency } from 'core/utils';
import { Input, InputProps } from './Input';
import * as React from 'react';
import { FieldValues, Path } from 'react-hook-form';

export type DecimalInputRef = HTMLInputElement;

export interface DecimalInputProps<T extends FieldValues, TPath extends Path<T>> extends Omit<InputProps<T, TPath>, 'formatFieldValue' | 'formatChangeEventValue'> {
	allowNegative?: boolean;
	precision?: number;
}

function getDecimalPattern({ allowNegative, precision }: { allowNegative: boolean; precision: number }): string {
	const sign = allowNegative ? '-?' : '';
	const separator = Currency.DECIMAL_SEPARATOR === '.' ? `[${Currency.DECIMAL_SEPARATOR}, \\,]` : `[\\${Currency.DECIMAL_SEPARATOR}, .]`;
	return `${sign}\\d+(${separator}\\d{0,${precision}})?`;
}

export const DecimalInput = <T extends FieldValues, TPath extends Path<T>>(props: DecimalInputProps<T, TPath>) => {

	const { allowNegative, precision, ...rest } = props;

	const formatFieldValue = React.useCallback((value: number | null) => {
		return value?.toString().replace('.', Currency.DECIMAL_SEPARATOR) || '';
	}, []);

	const unFormatFieldValue = React.useCallback((targetValue: string) => {
		// Aunque el usuario meta más decimales con el KeyPad, siempre me quedo con la precisión que me dijeron
		return targetValue.replace(Currency.DECIMAL_SEPARATOR, '.');
	}, []);

	return (
		<Input
			pattern={getDecimalPattern({ allowNegative: allowNegative ?? false, precision: precision ?? 2 })}
			autoComplete='off'
			formatFieldValue={formatFieldValue}
			unFormatFieldValue={unFormatFieldValue}
			// Pongo que son de tipo text para poder manejar el . del teclado numérico y con nuestro Keypad. 
			// Si el usuario quiere cambiar el tipo que lo pase por props
			type='text'
			{...rest}
		/>
	);
};